export const MARKETING_ONLY_USER_UIDS = [
  'kRX6KumP2RgG4F2hXETsU4t6TQs1', // Сніжана
  'RSOTdGAZtegRp6snnEYiWIGXGiu2', // Олександра
]

export const isMarketingOnlyUser = (uid) => MARKETING_ONLY_USER_UIDS.includes(uid)

export const canEditCampaignLink = ({ uid, responsible, marketingOnly = isMarketingOnlyUser(uid) }) => {
  if (!marketingOnly) {
    return true
  }

  return Boolean(uid && responsible && responsible === uid)
}

export const canManageAmeCampaigns = (user) => {
  if (!user?.uid) {
    return false
  }
  if (isMarketingOnlyUser(user.uid)) {
    return false
  }
  // BackOffice login is email/password only (Auth.jsx).
  const providers = Array.isArray(user.providerData) ? user.providerData : []
  return providers.some((provider) => provider?.providerId === 'password')
}
